import { ChevronRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { PROCESS } from "@/content";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="bg-white py-16 lg:py-20">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>Our Process</Eyebrow>
          <h2 data-testid="process-title" className="headline mt-3 text-3xl sm:text-4xl">Simple. Fast. Done right.</h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1} className="relative flex gap-5 lg:pr-10">
              <span className="font-head font-light text-5xl leading-none tracking-tight">{p.n}</span>
              <div data-testid={`process-step-${p.n}`}>
                <h3 className="font-head font-bold uppercase text-[12px] tracking-[0.02em]">{p.title}</h3>
                <p className="mt-2 text-[14px] text-[var(--body)] leading-snug max-w-[200px]">{p.text}</p>
              </div>
              {i < PROCESS.length - 1 && <ChevronRight className="hidden lg:block absolute right-3 top-3 h-5 w-5" strokeWidth={1.5} />}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
